export const LOAD_REGIONS_SUCCESS = 'LOAD_REGIONS_SUCCESS';
export const CREATE_REGION_SUCCESS = 'CREATE_REGION_SUCCESS';
export const EDIT_REGION_SUCCESS = 'EDIT_REGION_SUCCESS';
export const UPDATE_REGION_SUCCESS = 'UPDATE_REGION_SUCCESS';
export const DELETE_REGION_SUCCESS = 'DELETE_REGION_SUCCESS';
